import React from "react";
var __jsx = React.createElement;
import { CDN_LINK } from "@globalConfig";
import { useTranslation } from "@i18n";
var HeroSection = function HeroSection() {
  var _useTranslation = useTranslation(),
    tShort = _useTranslation.tShort,
    tLong = _useTranslation.tLong;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("section", {
    className: "relative h-[395px] w-full lg:h-[790px]"
  }, /*#__PURE__*/React.createElement("img", {
    src: CDN_LINK + "/assets/images/about-us/hero.webp",
    alt: tLong("about_us/hero_alt", {
      ns: "web_common"
    }),
    className: "absolute w-full h-full object-cover object-center",
    width: "1440",
    height: "790"
  }), /*#__PURE__*/React.createElement("div", {
    className: "absolute bg-[linear-gradient(180deg,_rgba(182,192,243,0.06)_0.62%,_rgba(7,21,86,0.48)_100%)] h-full w-full flex items-center justify-center"
  }, /*#__PURE__*/React.createElement("div", {
    className: "text-center px-7 flex flex-col items-center justify-center gap-4 md:gap-12"
  }, /*#__PURE__*/React.createElement("h1", {
    className: "text-white text-3xl font-bold md:text-7xl"
  }, tShort("about_us/hero_title", {
    ns: "web_common"
  })), /*#__PURE__*/React.createElement("p", {
    className: "text-white font-medium text-2xl md:text-[32px]"
  }, tLong("about_us/hero_subtitle", {
    ns: "web_common"
  }))))));
};
export default HeroSection;